// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2463":"20ee4a4270d813ad","2760":"197bb61b8db26e7f"}[chunkId] + ".css";
};